<template>
  <div>
    <PageTitleVue sub-title="Gestão do conteúdo da plataforma">
      conteúdo
    </PageTitleVue>

    <Form
      :description-title="'Faça a gestão dos destaques e imagens do app'"
    >
      <Create
        :disable="disabledForUpload"
        @click="addItem()"
        :icon="PhCheck"
        label="Salvar"
      />
    </Form>
  </div>
</template>

<script setup>
import PageTitleVue from './../../components/Titles/PageTitle.vue'
import { onBeforeMount, ref, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataStock } from './store'
import Form from './layout/Form.vue'
import Create from '@/components/Buttons/Create.vue'
import EventService from '@/modules/events/service/event.service'
import { PhCheck } from '@phosphor-icons/vue'
import stockService from './services/stock.service'

import { storeApp } from '@/store'
// import SharedService from '@/shared/services/shared'

const store = dataStock
const disabledForUpload = computed(() => dataStock.getters.getStateForButton)

async function getEvents () {
  await EventService.getComboEvents()
    .then((res) => {
      dataStock.dispatch('setEventsCollect', res.data)
    })
    .catch((err) => {
      toast(
        'Aviso',
        'Algo deu errado o buscar seus eventos',
        'error'
      )
    })
}

async function addItem () {
  storeApp.state.loading = true

  await stockService.setStarted(store.state.data)
    .then(res => {
      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    }).catch(err => {
      console.log(err)

      toast(
        'Aviso',
        'Algo deu errado ao salvar configurações',
        'error'
      )
    })
  storeApp.state.loading = false
}

async function getCarousel () {
  // await SharedService.getCarroussel()
  //   .then((res) => {
  //     if (res.data.carousel) { store.state.data.carousel = res.data.carousel }
  //   })
  //   .catch((err) => {
  //     console.log(err)

  //     toast(
  //       'Aviso',
  //       'Não foi possivel buscar imagens do carrossel',
  //       'error'
  //     )
  //   })
}

async function getMainDesc () {
  // await SharedService.getMainDesc()
  //   .then((res) => {
  //     if (res.data.mainDesc) { store.state.data.mainDesc = res.data.mainDesc }
  //   })
  //   .catch((err) => {
  //     console.log(err)

  //     toast(
  //       'Aviso',
  //       'Não foi possivel buscar descrição inicial',
  //       'error'
  //     )
  //   })
}

async function getMainEvent () {
  // await SharedService.getMainEvent()
  //   .then((res) => {
  //     if (res.data.mainEvent.value) {
  //       const r = JSON.parse(res.data.mainEvent.value)

  //       store.state.data.mainEvent = {
  //         name: r.name,
  //         value: r.id
  //       }
  //     }
  //   })
  //   .catch((err) => {
  //     console.log(err)

  //     toast(
  //       'Aviso',
  //       'Não foi possivel buscar evento principal',
  //       'error'
  //     )
  //   })
}

async function getHighlights () {
  // await SharedService.getHighlights()
  //   .then((res) => {
  //     if (res.data.highlights) { store.state.data.highlights = res.data.highlights }
  //   })
  //   .catch((err) => {
  //     console.log(err)

  //     toast(
  //       'Aviso',
  //       'Não foi possivel buscar destaques',
  //       'error'
  //     )
  //   })
}

async function getLoginBanner () {
  // await SharedService.getBannerLogin()
  //   .then((res) => {
  //     store.state.data.loginImage = res.data?.loginBanner
  //   })
  //   .catch((err) => {
  //     console.log(err)
  //   })
}

onBeforeMount(() => {
  store.commit('reset')
  getEvents()
  Promise.all([
    getCarousel(),
    getMainDesc(),
    getMainEvent(),
    getHighlights(),
    getLoginBanner()
  ])
})
</script>
